
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AlertBox',
  props: {
    textColor: {
      type: String,
      default: 'text-vanilla-100 text-opacity-70'
    },
    bgColor: {
      type: String,
      default: 'bg-robin'
    }
  }
})
